import styled from "styled-components";
import { md, sm } from "../../../BreakPoints";

export const BgContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.45;

  ${md({
    opacity: "0.3",
  })}
`;

export const Container = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.6rem 1rem 1.1rem;
  background: radial-gradient(circle at 12% 0%, rgba(59, 99, 247, 0.15), transparent 32%),
    radial-gradient(circle at 90% 16%, rgba(46, 196, 182, 0.12), transparent 28%), var(--ice-blue);
`;

export const BrandIconContainer = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  margin-bottom: 1.2rem;
  padding: 0;
`;

export const Icon = styled.img`
  display: block;
  width: 172px;
  height: auto;
`;

export const FormSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 430px;
  border-radius: 0.85rem;
  padding: 1.6rem 1.5rem 1.2rem;
  background: var(--surface-white);
  border: 1px solid var(--line-mid);
  box-shadow: 0 16px 34px rgba(30, 57, 112, 0.1);

  ${sm({
    padding: "1.2rem 0.9rem 1rem",
    borderRadius: "0.75rem",
  })}
`;

export const Form = styled.form`
  display: grid;
  gap: 0.72rem;
`;

export const Title = styled.h1`
  color: var(--deep-navy);
  font-size: 1.3rem;
`;

export const Subtitle = styled.p`
  margin-top: -0.08rem;
  color: var(--text-muted);
  font-size: 0.86rem;
  line-height: 1.45;
`;

export const Input = styled.input`
  width: 100%;
  outline: none;
  font-size: 0.89rem;
  border-radius: 0.55rem;
  padding: 0.68rem 0.8rem;
  border: 1px solid var(--line-mid);
  background-color: var(--surface-soft);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &::placeholder {
    color: var(--slate);
  }

  &:focus {
    border-color: var(--brand-blue);
    box-shadow: 0 0 0 3px rgba(59, 99, 247, 0.16);
  }
`;

export const Button = styled.button`
  margin-top: 0.2rem;
  border: none;
  width: 100%;
  border-radius: 0.58rem;
  padding: 0.68rem 0.95rem;
  color: var(--surface-white);
  cursor: pointer;
  font-family: var(--font-display);
  font-size: 0.88rem;
  font-weight: 700;
  background: var(--brand-blue);
  box-shadow: 0 8px 16px rgba(46, 91, 170, 0.24);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(59, 99, 247, 0.3);
  }
`;

export const Hr = styled.hr`
  width: 100%;
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid rgba(46, 83, 153, 0.16);
  margin: 0.35rem 0 0.15rem;
  padding: 0;
`;

export const Link = styled.a`
  display: inline-flex;
  justify-content: center;
  text-decoration: none;
  color: var(--brand-blue);
  cursor: pointer;
  font-size: ${(props) => props.fontSize};
  font-weight: 600;

  &:hover {
    color: var(--brand-blue-strong);
  }
`;

export const Helper = styled.p`
  margin-top: 0.2rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.75rem;
`;
